import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { getLabConfig } from '../../utils/api';

const CloverCardForm = (props) => {
	console.log("ccf");
	console.log(props);
  const navigate = useNavigate();
  const [elements, setElements] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false); // To show loading state when processing payment
  const [errorMessage, setErrorMessage] = useState(""); // To show error messages
  
  // Use refs to track if elements are mounted
  const cardNumberMounted = useRef(false);
  const cardDateMounted = useRef(false);
  const cardCvvMounted = useRef(false);
  const cardPostalMounted = useRef(false);
  const cardElementsRef = useRef({});

  const cloverRef = useRef(null);

  const amount=Number(props.amount);
  const zip=props.zip;
  const email=props.email;
  const fname=props.fname;
  const lname=props.lname;
  const refid=props.refid;
	
  const [backend,setBackend]=useState('');

	const containerStyle = {
	  maxWidth: "500px",
	  margin: "0 auto",
	  padding: "20px",
	};
	const inputWrapper = {
		base: {
		  marginBottom: "12px",
		  maxWidth: "400px",
		  margin: "0 auto",
		  fontFamily: "Arial, sans-serif",
		  padding: "20px",
		},
		label:  {
		  display: "block",
		  marginBottom: "4px",
		  fontWeight: "500",
		  color: "#2c3e50",
		}		
	};
	const cloverInput = {
		  border: "1px solid #ccc",
		  padding: "6px 12px",
		  height: "36px", 
		  fontSize: "14px",
		  lineHeight: "20px",
		  borderRadius: "6px",
		  background: "#fff",
		  boxSizing: "border-box",
	};
	const cloverText = {
	  marginBlock: "0.67em",
	  fontSize: "2em",
	};
	const payButton = {
		  backgroundColor: "#044B93",
		  color: "white",
		  padding: "10px 14px", 
		  fontSize: "16px",
		  border: "none",
		  borderRadius: "6px",
		  cursor: "pointer",
		  width: "100%",
		  marginTop: "20px",
	};
  	useEffect(() => {
        async function fetchServer() {
            let backendsetting = await getLabConfig('DTCBACKENDSERVER');
				  if (process.env.NODE_ENV !== 'production' ){
					backendsetting = "http://localhost:4242";
					}
            setBackend(backendsetting);
        }
        fetchServer();
    }, []);

  useEffect(() => {
	let cardNumber='';
	let cardDate='';
	let cardCvv='';
	let cardZip='';
    const script = document.createElement("script");
    script.src = "https://checkout.sandbox.dev.clover.com/sdk.js";
    script.async = true;

    script.onload = () => {
      if (!window.Clover) {
        console.error("Clover SDK failed to load.");
        return;
      }
	  //const clover = new window.Clover('b3114dfafd6aa0b67e1bc6450b87b09b');
      const clover = new window.Clover('b3114dfafd6aa0b67e1bc6450b87b09b',{
		  merchantId: '7K754ZW4WY491'
	  });
	  cloverRef.current = clover;
      const els = clover.elements();
      setElements(els);
	  
	const inputStyle = {
        base: {
          color: "#2c3e50",
          fontSize: "16px",
          fontFamily: "Arial, sans-serif",
          padding: "10px",
          "::placeholder": {
            color: "#95a5a6",
          },
        },
        focus: {
          color: "#000",
        },
        invalid: {
          color: "#e74c3c",
        },
      };

      // Mount only if not already mounted
		if (!cardNumberMounted.current) {
		  cardNumber = els.create("CARD_NUMBER", { style: inputStyle });
		  cardNumber.mount("#card-number");
		  cardNumberMounted.current = true;
		}

		if (!cardDateMounted.current) {
		  cardDate = els.create("CARD_DATE", { style: inputStyle });
		  cardDate.mount("#card-date");
		  cardDateMounted.current = true;
		}

		if (!cardCvvMounted.current) {
		  cardCvv = els.create("CARD_CVV", { style: inputStyle });
		  cardCvv.mount("#card-cvv");
		  cardCvvMounted.current = true;
		}

		if (!cardPostalMounted.current) {
		  cardZip = els.create("CARD_POSTAL_CODE", { style: inputStyle });
		  cardZip.mount("#card-postal");
		  cardPostalMounted.current = true;
		}

		// Save mounted elements to ref
		cardElementsRef.current = { cardNumber, cardDate, cardCvv, cardZip };
	};
    document.body.appendChild(script);

  }, []);

	const handlePayment = async () => {
	  setErrorMessage("");
		setLoading(true);

		const clover = cloverRef.current;

		if (!clover) {
		  setErrorMessage("Clover is not initialized.");
		  setLoading(false);
		  return;
		}

	  try {
		setLoading(true);
		const result = await clover.createToken();

		if (result.errors) {
		  console.error("Tokenization Errors:", result.errors);
		  setErrorMessage("Tokenization error: " + result.errors.map(e => e.message).join(", "));
		  setLoading(false);
		  return;
		}


		const token = result.token;
		setToken(token);
		const amount100=amount*100;
		const labid='PREMIER';
		// Send token to backend
		const res = await fetch(`${backend}/clover/process-payment`, {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify({ token, amount100, labid, email, fname, lname, refid }),
		});

		const data = await res.json();
		if (data.success) {
			navigate(`/orderSuccessful?session_id=${data.ccid}`);
		} else {
		  setErrorMessage("Payment failed.");
		  navigate(`/creditCardFailed`);
		}

		setLoading(false);
	  } catch (err) {
		console.error("Payment error:", err);
		setErrorMessage("Unexpected error");
		setLoading(false);
	  }
	};

  return (
    <div style={containerStyle}>
	   <div style={cloverText}>Clover Payment <br/>
			Total: ${amount.toFixed(2)}</div>
      <div style={inputWrapper}>
        <label>Card Number</label>
        <div id="card-number" style={cloverInput} />

        <label>Expiration Date</label>
        <div id="card-date" style={cloverInput} />

        <label>CVV</label>
        <div id="card-cvv" style={cloverInput} />

        <label>Postal Code</label>
        <div id="card-postal"style={cloverInput} />
      </div>

	<button onClick={handlePayment} style={payButton} disabled={loading}>
	  {loading ? "Processing..." : "Pay"}
	</button>

	{errorMessage && (
	  <p style={{ color: "red", marginTop: "10px" }}>
		{errorMessage}
	  </p>
	)}

	{token && (
	  <p style={{ color: "green", marginTop: "10px" }}>
		✅ Token created
	  </p>
)}

    </div>
  );
};

export default CloverCardForm;
